import {
  CATEGORY_EVERYTHING_ID,
  HomeActions,
  CarouselActions,
  FilteredActions,
  ActivePageActions,
  ChangeFilterAction,
} from './actions';

const initialState = {
  carouselPages: [],
  filteredPages: {
    totalCount: 0,
    pageNo: 1,
    items: [],
  },
  filter: {
    categoryId: CATEGORY_EVERYTHING_ID,
    typeId: 0,
    locationId: 0,
  },
  activePagesCount: 0,
  isLoading: false,
  loaded: false,
  error: null,
};

type Action =
  | HomeActions
  | CarouselActions
  | FilteredActions
  | ActivePageActions
  | ChangeFilterAction;

export default function reducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'HOME_REQUEST':
      return {
        ...state,
        isLoading: true,
      };

    case 'HOME_SUCCESS':
      return {
        ...state,
        isLoading: false,
        loaded: true,
      };

    case 'HOME_FAILURE':
      return {
        ...state,
        isLoading: false,
        loaded: false,
        error: action.payload,
      };

    case 'CAROUSEL_PAGES_SUCCESS': {
      const items = action.payload.items || [];

      return {
        ...state,
        carouselPages: items.slice(0, 5),
      };
    }
    case 'FILTERED_PAGES_REQUEST':
      return {
        ...state,
        isLoading: true,
      };
    case 'FILTERED_PAGES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        filteredPages: {
          totalCount: action.payload.totalCount,
          pageNo: action.payload.pageNo,
          items:
            action.payload.pageNo === 1
              ? action.payload.items
              : [...state.filteredPages.items, ...action.payload.items],
        },
      };
    case 'FILTERED_PAGES_FAILURE':
      return {
        ...state,
        isLoading: false,
      };
    case 'CHANGE_PAGES_FILTER':
      return {
        ...state,
        filter: action.payload.filter,
      };
    case 'ACTIVE_PAGES_COUNT_SUCCESS':
      return {
        ...state,
        activePagesCount: action.payload.activePagesCount,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/home/reducer.ts